import {
  createArraySomeErrorDiagnostics,
  editorDiagnosticStep,
} from '~/utils/arraySomeErrorDiagnostics'

export default defineNuxtPlugin({
  name: 'gcb-array-some-error-context',
  dependsOn: ['posthog'],
  setup(nuxtApp) {
    const posthog = nuxtApp.$clientPosthog
    const environment = useRuntimeConfig().public.posthog.environment
    if (!posthog || !['dev', 'prod'].includes(environment)) return
    const diagnostics = createArraySomeErrorDiagnostics()
    const router = useRouter()
    document.addEventListener(
      'click',
      (event) => {
        if (!editorDiagnosticStep(router.currentRoute.value.path)) return
        const target = event.target
        if (!(target instanceof Element)) return
        const button = target.closest('button')
        if (button) diagnostics.record(button.textContent?.trim() ?? '')
      },
      { capture: true },
    )
    const previous = posthog.config.before_send
    const callbacks = previous
      ? Array.isArray(previous)
        ? previous
        : [previous]
      : []
    posthog.set_config({
      before_send: [
        ...callbacks,
        (event) =>
          event &&
          diagnostics.enrich(event, {
            step: editorDiagnosticStep(router.currentRoute.value.path),
            buildId: nuxtApp.$config.app.buildId,
            embedded: window.self !== window.top,
          }),
      ],
    })
  },
})
